<template>
  <div class="TopCompetitions-styles-top-competitions">
    <h3 class="Navigation-styles-nav-section-title" v-html="(compact) ? t.top : t.top_competitions"></h3>
    <div id="navigation-links-topcompetitions" class="" @click="refreshPage()">
      <router-link :to="{name: 'Sportsbook', query: {c: [c.competition.competitionId]}}" class="NavigationAllMatches-styles-link" v-for="c in competitions">
        <img class="NavigationAllMatches-styles-icon" :src="'/static/assets/img/'+c.sport.alias+'.png'" :alt="c.name" loading="lazy" width="20" height="20">
        <img class="NavigationAllMatches-styles-icon" style="display: none" :src="'https://statistics.bcapps.org/images/c/b/0/'+c.extended_id+'.png'" :alt="c.name" loading="lazy" width="20" height="20">
        <span class="NavigationAllMatches-styles-title">{{ c.competition.name }}</span>
      </router-link>
    </div>
  </div>

</template>

<script>
export default {
  name: 'topmCompetitions',
  data () {
    return {
      t: this.$root.t,
      competitions: null,
      compact: false
    }
  },
  mounted() {
    this.fetchCompetitions()

    var th = this
    this.$bus.$on('compact', (payload) => {

      th.compact = payload;

    });
  },
  methods: {
      fetchCompetitions(){
        this.competitions = [];
        this.$http.get(bsapi + 'matches.aspx',{
          params: {
            withoutMatch: 1,
          }
        }).then(response => {
          Object.values(response.data.result.sport).forEach((sport) => {
            Object.values(sport.region).forEach((region) => {
              Object.values(region.competition).forEach((competition) => {
                if(competition.isPopular)
                  this.competitions.push({order: region.order, competition: competition, region: region, sport: sport})
              })
            })
          })
        })
      },
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/widget/topCompetitions.vue